function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompass = function SvgCompass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.65 12a7.25 7.25 0 1 1-14.5 0 7.25 7.25 0 0 1 14.5 0Z",
    stroke: props.color,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.809 10.409 4.84-1.659-1.658 4.841-4.84 1.659 1.658-4.841Z",
    stroke: props.color,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export { SvgCompass as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5LjY1IDEyQzE5LjY1IDE2LjAwNDEgMTYuNDA0MSAxOS4yNSAxMi40IDE5LjI1QzguMzk1OTYgMTkuMjUgNS4xNTAwMiAxNi4wMDQxIDUuMTUwMDIgMTJDNS4xNTAwMiA3Ljk5NTk0IDguMzk1OTYgNC43NSAxMi40IDQuNzVDMTYuNDA0MSA0Ljc1IDE5LjY1IDcuOTk1OTQgMTkuNjUgMTJaIiBzdHJva2U9IiMxMTEwMTIiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEwLjgwOSAxMC40MDlMMTUuNjQ5OSA4Ljc0OTk3TDEzLjk5MSAxMy41OTFMOS4xNTAxNSAxNS4yNUwxMC44MDkgMTAuNDA5WiIgc3Ryb2tlPSIjMTExMDEyIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";